import { useState } from 'react';
import Dialog from '../../../../../../../BaseComponents/Dialog/EDDialog';
import EDTypography from '../../../../../../../BaseComponents/Typography/EDTypography';
import avenyLocalStorage from '../../../../../../../Utils/LocalStorage/avenyLocalStorage';
import { EKONOMISK_ANALYS_IGNORE_ROWS_WARNING_KEY } from '../../../../../../../Utils/LocalStorage/localStorageKeys';
import EDCheckbox from '../../../../../../../BaseComponents/Checkboxes/EDCheckbox';

interface IProps {
  open: boolean;
  setOpen: (open: boolean) => void;
}

// Gränsen i antal rader där varningen ska dycka upp
export const EKONOMISK_ANALYS_ROWS_WARNING_LIMIT = 100;

export const getIgnoreRowsWarning = () =>
  avenyLocalStorage.getItem<boolean | null>(
    EKONOMISK_ANALYS_IGNORE_ROWS_WARNING_KEY
  );

export const setIgnoreRowsWarning = (value: boolean) =>
  avenyLocalStorage.setItem<boolean>(
    EKONOMISK_ANALYS_IGNORE_ROWS_WARNING_KEY,
    value
  );

/**
 * En dialog som visas när en analys innehåller väldigt många rader och troligtvis laddar långsamt av den anledningen.
 */
const EkonomiskAnalysRowsWarningDialog: React.FunctionComponent<
  React.PropsWithChildren<IProps>
> = props => {
  const [ignoreWarning, setIgnoreWarning] = useState(false);

  const onClose = () => {
    props.setOpen(false);
  };

  return (
    <Dialog
      title="Analysen innehåller många rader"
      open={props.open}
      onClose={onClose}
      footerActions={[
        {
          label: 'Stäng',
          onClick: () => {
            setIgnoreRowsWarning(ignoreWarning);
            onClose();
          },
        },
      ]}
    >
      <EDTypography gutterBottom>
        Analysen innehåller fler än {EKONOMISK_ANALYS_ROWS_WARNING_LIMIT}{' '}
        summerade rader, detta kan göra att analysen blir långsam att arbeta
        med. Om du upplever att visningen av analysen blir långsam kan du göra
        ett snävare urval eller använda ett vidare summeringsbegrepp som första
        summeringsnivå för att få färre rader.
      </EDTypography>
      <EDCheckbox
        label={'Visa aldrig detta meddelande igen'}
        checked={ignoreWarning}
        onCheck={newValue => {
          setIgnoreWarning(newValue);
        }}
      />
    </Dialog>
  );
};

export default EkonomiskAnalysRowsWarningDialog;
